<template lang="">
    <v-app :lang="$i18n.locale">
    </v-app>
</template>
<script>
    import * as services from "@/services";
    import router from "@/router";
    export default {
        name: "ApplicationFormLanding",
        components: {},
        data: () => ({
            registerFormLink: null,
        }),
        methods: {
            async getRegisterFormConfigFromLink() {
                try {
                    this.registerFormLink = this.$route.params?.link;
                    localStorage.setItem("registerToken", this.$route.query?.token)
                    const res = await services.getRegisterFormIDFromLink({
                        link: this.registerFormLink,
                        token: this.$route.query?.token
                    });
                    localStorage.setItem("registerLink", this.registerFormLink)
                    if(res.data.status.code == 200 || res.data.status.code == 0){
                        if(res.data.data.timeout){
                            localStorage.removeItem("registerToken")
                            window.location.href = '/error'
                        }
                        router.push({
                            path: "/login",
                        });
                    }
                    else{
                        localStorage.removeItem("registerToken")
                        window.location.href = '/error'
                    }
                } catch (err) {
                    localStorage.removeItem("registerToken")
                    window.location.href = '/error';
                }
            },
        },
        mounted() {
            localStorage.removeItem("registerLink")
            this.getRegisterFormConfigFromLink();
        },
    };
</script>
<style lang=""></style>
